import escapeHTMLTags from '@sdk/utils/escapeHTMLTags';

export default function matchStrong() {
  return function link($scope, $element, $attrs) {
    function render(value = '', filter = '') {
      const regex = new RegExp(filter.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'gi');
      $element.html(
        escapeHTMLTags(value).replace(regex, (a) => `<strong>${escapeHTMLTags(a)}</strong>`)
      );
    }

    $scope.$watch($attrs.matchStrong, (filter) => {
      render($scope.$eval($attrs.bind), filter);
    });

    $scope.$watch($attrs.bind, (val) => {
      render(val, $scope.$eval($attrs.matchStrong));
    });
  };
}
